
<section
  class="relative w-full flex flex-col justify-center items-center bg-themeComponentBg-light font-rubik cities-served-outer-container"
  :class="{ 'products-page': page === 'products' }"
  aria-labelledby="cities-served-heading"
>
  <img
    src="@/images/cities-served/mobile-icon-01.svg"
    alt=""
    class="mobile-icon-01 1240-bp:hidden"
    aria-hidden="true"
  />

  <div class="w-full mx-5 max-w-1216" style="z-index: 2;">
    <h2 id="cities-served-heading" class="cities-served-title text-center">
      Cities served <br />
      by
      <span class="highlight">
        {{ organization ? organization.name : 'Container Alliance' }}
      </span>
    </h2>

    <nav
      class="flex flex-col 1240-bp:flex-row flex-wrap items-center justify-center"
      aria-label="List of cities we serve"
    >
      <ul class="flex flex-wrap items-center justify-center">
        <li
          v-for="(city, index) in visibleCities"
          :key="index"
          class="flex 1240-bp:flex-row flex-col"
        >
          <a :href="cityPath(city)" class="city-item min-w-298 max-w-298">
            <span>
              {{ truncateCityName(`${city.name}, ${city.stateId.toUpperCase()}`) }}
            </span>
            <img
              class="h-4"
              src="@/images/cities-served/arrow-outward.svg"
              alt=""
              aria-hidden="true"
            />
          </a>

          <button
            v-if="visibleCities.length === index + 1 && pageInfo.hasNextPage"
            @click="loadMoreCities"
            class="load-more-btn min-w-298 max-w-298"
            type="button"
            aria-label="Load more cities"
          >
            <span>{{ loading ? 'Loading...' : 'Load more' }}</span>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</section>
